import APP_ITEMS from '../items/apps';
import { createApp, createThirdApp } from '../layoutItems';
import { useLayoutApp, useMenu } from '@/store';
import { TItem } from '@/components/GridBoards/types';
import { isNotInSider } from '../doWithSider';

type ReturnOfUseApps = [TItem[], (arg: TItem[]) => void];

const useApps = (
  screen: number,
  siderbounds: LayoutBoxSiderbounds,
): ReturnOfUseApps => {
  const [app = [], updateLayoutApp] = useLayoutApp();
  const [{ thirdApp = [] }] = useMenu();

  const result: TItem[] = app
    .filter((a) => {
      return a.screen === screen;
    })
    .map<TItem>((a) => {
      // 三方app
      const mta = thirdApp.find((tha) => tha.className === a.className);
      if (mta) {
        return createThirdApp(
          {
            className: mta.className,
            x: a.x,
            y: a.y,
            title: mta.displayName,
          },
          siderbounds,
        );
      }

      // 内置app
      return createApp(a, siderbounds);
    });

  /**
   * 更新app
   */
  const updateApps = (items: TItem[]) => {
    /**
     * 存在与 APP_ITEMS中且 x < col - 1 的 都是app
     */
    const tmp: PropType<ConfigLayout, 'app'> = [];
    items.forEach((i) => {
      const _id = i.id as keyof typeof APP_ITEMS;
      if (APP_ITEMS[_id] && isNotInSider(i.x, i.y, siderbounds)) {
        tmp.push({
          className: _id,
          packageName: APP_ITEMS[_id].packageName,
          screen: screen,
          x: i.x,
          y: i.y,
        });
        return false;
      }
      // matchedThirdApp
      const mta = thirdApp.find((tha) => tha.className === i!.id);
      if (mta) {
        tmp.push({
          className: mta.className,
          packageName: mta.packageName,
          screen: screen,
          x: i.x,
          y: i.y,
        });
      }
    });

    const _app = app!.filter((a) => a.screen !== screen);

    updateLayoutApp([..._app, ...tmp]);
  };

  return [result, updateApps];
};

export default useApps;
